import { DimensionTypes } from "./DimensionTypes/DimensionTypes";
import { BulkResizerSize } from "./Size/BulkResizerSize";
import { DPI } from "./DPI/DPI";
import { Percentage } from "./Percentage/Percentage";
import { useBulkResizeSettings } from "./useBulkResizeSettings";
import { FillColor } from "./FillColor/FillColor";
import { AddImages } from "../../ControlBar/AddImages/AddImages";
import { Sort } from "../../ControlBar/Sort/Sort";
import { DeleteAll } from "../../ControlBar/DeleteAll/DeleteAll";
import { DesktopAction } from "../../Action/DesktopAction";
import { ExportSettings } from "../../ExportSettings/ExportSettings";
import { ArrowIcon } from "components/common/Icons/ArrowIcon";
import { Translate } from "components/common/Translate/Translate";
import SocialMediaPlatform from "./SocialMediaPlatform/SocialMediaPlatform";
import SocialMediaPresetPlatformPreset from "./SocialMediaPlatform/PresetType/PresetType";
import { SizeForSocialMedia } from "./Size/sizeForSocialMedia";
import { useSize } from "./Size/useSize";
import { useAppSelector } from "@/store/store";
import { Unit } from "./Unit/Unit";
import { MaxFileSizeIndicatorText } from "@/components/common/Uploader/MaxFileSizeIndicator/MaxFileSizeIndicatorText";

export const BulkResizeSettings = () => {
    const { dimensionType, isExportSettingsOpen, toggleExportSettings } = useBulkResizeSettings();
    const { unit, handleUnitChange } = useSize();
    const isLocked = useAppSelector((store) => store.bulkResize.resizeSettings.isLocked);

    return (
        <div className="h-full flex flex-col">
            <div className="lg:flex lg:flex-col h-full w-full bg-white dark:bg-darkSurface-100">
                {/* Header with controls - fixed */}
                <div className="hidden lg:block flex-shrink-0 border-b border-b-irGray-200 dark:border-b-darkSurface-600">
                    <div className="px-4 py-3.5 flex flex-col gap-2">
                        <div className="gap-4 flex items-center justify-between">
                            <AddImages />
                            <div className="flex items-center gap-4">
                                <Sort />
                                <DeleteAll />
                            </div>
                        </div>
                        <MaxFileSizeIndicatorText />
                    </div>
                </div>

                {/* Title - fixed */}
                <div className="hidden lg:block flex-shrink-0 capitalize text-2xl font-semibold px-6 pt-4 dark:text-white">
                    <Translate keyName="resize-settings" />
                </div>

                {/* Scrollable content section */}
                <div className="flex-grow overflow-y-auto">
                    <div className="flex flex-col gap-1 px-4 text-black dark:text-white">
                        <DimensionTypes />
                        {dimensionType === "pixels" ? (
                            <>
                                <BulkResizerSize />
                                <FillColor />
                                {unit !== "pixels" && <DPI />}
                            </>
                        ) : dimensionType === "socialMedia" ? (
                            <>
                                <SocialMediaPlatform />
                                <SocialMediaPresetPlatformPreset />
                                <SizeForSocialMedia />
                                {!isLocked && <FillColor />}
                                <Unit unit={unit} handleUnitChange={handleUnitChange} />
                                {unit !== "pixels" && <DPI />}
                            </>
                        ) : (
                            <Percentage />
                        )}
                    </div>
                    <div className="py-8">
                        <div className="cursor-pointer flex items-center p-4" onClick={toggleExportSettings}>
                            <div className="font-semibold text-2xl dark:text-white">
                                <Translate keyName="export-settings" />
                            </div>
                            <div className="ml-auto">
                                {!isExportSettingsOpen ? (
                                    <div>
                                        <ArrowIcon width={15} height={15} />
                                    </div>
                                ) : (
                                    <div className="rotate-180">
                                        <ArrowIcon width={15} height={15} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {isExportSettingsOpen && <ExportSettings />}
                    </div>
                </div>

                {/* Footer - fixed at bottom */}
                <div className="flex-shrink-0 mt-auto w-full hidden lg:block">
                    <div className="bg-white dark:bg-darkSurface-100 border-t border-t-irGray-200 dark:border-t-darkSurface-600 px-1 py-2">
                        <DesktopAction />
                    </div>
                </div>
            </div>
        </div>
    );
};

